/*
  Product payment terms

  This file owns the loading placeholder for Shopify's asynchronous installment message.
  Shopify remains responsible for eligibility, payment copy, and installment interactions.
*/

class ProductPaymentTerms extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector("form");

    if (!this.form || !this.querySelector("shopify-payment-terms")) {
      this.finishLoading();
      return;
    }

    this.resizeObserver = new ResizeObserver(() => this.checkContent());
    this.resizeObserver.observe(this.form);
    this.loadingTimeout = window.setTimeout(() => this.finishLoading(), 10000);
    this.checkContent();
  }

  disconnectedCallback() {
    this.resizeObserver?.disconnect();
    window.clearTimeout(this.loadingTimeout);
  }

  checkContent() {
    if (this.form.getBoundingClientRect().height > 0) this.finishLoading();
  }

  finishLoading() {
    this.removeAttribute("data-loading");
    this.removeAttribute("aria-busy");
    this.resizeObserver?.disconnect();
    window.clearTimeout(this.loadingTimeout);
  }
}

if (!customElements.get("product-payment-terms")) {
  customElements.define("product-payment-terms", ProductPaymentTerms);
}
